import styled from 'styled-components/macro';

export const StyledTable = styled.table`
  display: table;
  width: 100%;
  border-collapse: seperate;
  border-spacing: 0;
  ${({ theme }) => theme.font.small};
`;
